import React from 'react';
import PropTypes from 'prop-types';

import { ToolTip } from 'components/common/tooltips';
import { INBOUND } from 'constants/messageDirection';
import { MessageTimeMarkerText, TimeDisparityIcon } from './MessageTimeMarker.styles';

const MessageTimeMarker = ({
  isAdmin,
  messageDirection,
  messageReceivedTime,
  messageCreatedTime,
  messageTimeDiffExists,
}) => {
  if (isAdmin && messageDirection === INBOUND) {
    return (
      <>
        <ToolTip arrow placement="top" content={`Received by Simplr: ${messageReceivedTime}`}>
          <MessageTimeMarkerText>{`Created at: ${messageCreatedTime}`}</MessageTimeMarkerText>
        </ToolTip>
        {messageTimeDiffExists && (
          <TimeDisparityIcon alt="message time difference" src="/images/conversationIcons/no-connection-icon.svg" />
        )}
      </>
    );
  }

  return <MessageTimeMarkerText>{`Created at: ${messageCreatedTime}`}</MessageTimeMarkerText>;
};

export default MessageTimeMarker;

MessageTimeMarker.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  messageTimeDiffExists: PropTypes.bool.isRequired,
  messageDirection: PropTypes.string.isRequired,
  messageReceivedTime: PropTypes.string.isRequired,
  messageCreatedTime: PropTypes.string.isRequired,
};
